import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

var ModalVincularProposta = ({ show, onHide, imovel, onVincular }) => {
  var numState = useState('');
  var numeroProposta = numState[0]; var setNumeroProposta = numState[1];
  var loadingState = useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];

  var handleConfirmar = () => {
    var num = parseInt(numeroProposta, 10);
    if (!num || num <= 0) {
      toast.error('Informe um número de proposta válido.');
      return;
    }
    setLoading(true);
    onVincular({ codigo_ativo: imovel.codigo_ativo, numero_proposta: num })
      .then(() => {
        toast.success('Proposta vinculada com sucesso.');
        setNumeroProposta('');
        onHide();
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao vincular proposta';
        toast.error(msg);
      })
      .finally(() => setLoading(false));
  };

  var handleHide = () => {
    setNumeroProposta('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} size="sm">
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: 'white' }}>
        <Modal.Title style={{ fontSize: 15 }}>Vincular Proposta de Venda</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label style={{ fontSize: 13 }}>Número da Proposta</Form.Label>
          <Form.Control
            type="number"
            size="sm"
            value={numeroProposta}
            onChange={(e) => setNumeroProposta(e.target.value)}
            placeholder="Nº da proposta"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="sm" onClick={handleConfirmar} disabled={loading}>
          {loading ? 'Salvando...' : 'Confirmar'}
        </Button>
        <Button variant="secondary" size="sm" onClick={handleHide}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalVincularProposta;
